const on = (selector, eventType, childSelector, eventHandler) => {
  const elements = document.querySelectorAll(selector);
  Array.from(elements).forEach(element => {
    element.addEventListener(eventType, eventOnElement => {
      if (eventOnElement.target.matches(childSelector)) {
        eventHandler(eventOnElement);
      }
    });
  });
};

export default on;



// WEBPACK FOOTER //
// ./scripts/util/on.js